import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { User } from '../types/User';
import { getCurrentUser, updateUserReadNews } from '../dataProviders/user';

export const useUserStore = defineStore('user', () => {
  const isProfileFetching = ref(true);
  const profile = ref<User>({
    id: 1,
    tag: '',
    created_at: '2023-12-02T12:00:00Z',
    email: '',
    status: 'inactive',
    access_level: 'User',
    info: {
      name: '',
      phone: '',
      city: '',
    },
    invoicing: {
      name: '',
      eik: '',
      address: '',
      mol: '',
    },
    terms: true,
    addresses: {
      ourCourier: {
        name: '',
        phone: '',
        city: 'Варна',
        address: '',
        note: '',
      },
      courierAddress: {
        name: '',
        phone: '',
        city: 'Sofia',
        address: '',
        note: '',
        courier: 'ekont',
      },
      courierOffice: {
        name: '',
        phone: '',
        city: '',
        office: '',
        note: '',
        courier: 'speedy',
      },
    },
    read_news: []
  });
  const isAuthenticated = ref(false);

  function setProfile(data: User) {
    profile.value = data;
    isAuthenticated.value = true;
  }

  async function loadUserProfile(): Promise<boolean> {
    try {
      if (isAuthenticated.value)
        return true;
      const data = await getCurrentUser();

      if (data) {
        setProfile(data)
      }
      return true
    } catch (e) {
      console.error('Login failed with', e)
      return false
    } finally {
      isProfileFetching.value = false;
    }
  }

  async function setUserNewsAsRead(selectedNewsId: number): Promise<void> {
    if (profile.value.read_news.includes(selectedNewsId)) return;

    profile.value.read_news.push(selectedNewsId)
    updateUserReadNews(profile.value.id, profile.value.read_news)
  }

  return { profile, isAuthenticated, isProfileFetching, setProfile, loadUserProfile, setUserNewsAsRead };
});

export type UserStoreType = Omit<
  ReturnType<typeof useUserStore>,
  keyof ReturnType<typeof defineStore>
>;
